export default [
    {
        path: '/pages/inspection/inspectionPoint',
        name: '/pages/inspection/inspectionPoint',
        component: () => import('@/views/inspection/inspectionPointList.vue')
    },
    {
        path: '/pages/inspection/inspectionRoute',
        name: '/pages/inspection/inspectionRoute',
        component: () => import('@/views/inspection/inspectionRouteList.vue')
    },
    {
        path: '/pages/inspection/adminInspectionPlan',
        name: '/pages/inspection/adminInspectionPlan',
        component: () => import('@/views/inspection/adminInspectionPlanList.vue')
    },
    {
        path: '/pages/inspection/aInspectionPlanDetail',
        name: '/pages/inspection/aInspectionPlanDetail',
        component: () => import('@/views/inspection/aInspectionPlanDetailList.vue')
    },
    {
        path: '/pages/inspection/adminInspectionTask',
        name: '/pages/inspection/adminInspectionTask',
        component: () => import('@/views/inspection/adminInspectionTaskList.vue')
    },
    {
        path: '/views/inspection/adminInspectionTaskDetail',
        name: '/views/inspection/adminInspectionTaskDetail',
        component: () => import('@/views/inspection/adminInspectionTaskDetailList.vue')
    },
    {
        path: '/pages/property/inspectionItemManage',
        name: '/pages/property/inspectionItemManage',
        component: () => import('@/views/inspection/inspectionItemManageList.vue')
    },
    {
        path: '/views/inspection/inspectionItemTitleManage',
        name: '/views/inspection/inspectionItemTitleManage',
        component: () => import('@/views/inspection/inspectionItemTitleManageList.vue')
    },
    {
        path: '/pages/inspection/inspectionPlan',
        name: '/pages/inspection/inspectionPlan',
        component: () => import('@/views/inspection/inspectionPlanList.vue')
    },
    {
        path: '/views/inspection/addInspectionPlan',
        name: '/views/inspection/addInspectionPlan',
        component: () => import('@/views/inspection/addInspectionPlanList.vue')
    },
    {
        path: '/pages/inspection/inspectionTask',
        name: '/pages/inspection/inspectionTask',
        component: () => import('@/views/inspection/InspectionTaskList.vue')
    },
    {
        path: '/pages/property/inspectionTaskDetails',
        name: '/pages/property/inspectionTaskDetails',
        component: () => import('@/views/inspection/inspectionTaskDetailsList.vue')
    },
    {
        path: '/pages/property/maintainanceItem',
        name: '/pages/property/maintainanceItem',
        component: () => import('@/views/inspection/maintainanceItemList.vue')
    },
    {
        path: '/pages/property/maintainanceStandardManage',
        name: '/pages/property/maintainanceStandardManage',
        component: () => import('@/views/inspection/maintainanceStandardManageList.vue')
    },
    {
        path: '/views/inspection/maintainanceStandardItem',
        name: '/views/inspection/maintainanceStandardItem',
        component: () => import('@/views/inspection/maintainanceStandardItemList.vue')
    },
    {
        path: '/pages/property/maintainancePlanManage',
        name: '/pages/property/maintainancePlanManage',
        component: () => import('@/views/inspection/maintainancePlanManageList.vue')
    },
    {
        path: '/views/inspection/addMaintainancePlan',
        name: '/views/inspection/addMaintainancePlan',
        component: () => import('@/views/inspection/addMaintainancePlanList.vue')
    },
    {
        path: '/views/inspection/editMaintainancePlan',
        name: '/views/inspection/editMaintainancePlan',
        component: () => import('@/views/inspection/editMaintainancePlanList.vue')
    },
    {
        path: '/views/inspection/maintainancePlanMachine',
        name: '/views/inspection/maintainancePlanMachine',
        component: () => import('@/views/inspection/maintainancePlanMachineList.vue')
    },
    {
        path: '/pages/property/maintainanceTaskDetails',
        name: '/pages/property/maintainanceTaskDetails',
        component: () => import('@/views/inspection/maintainanceTaskDetailsList.vue')
    },
    {
        path: '/pages/property/maintainanceTaskManage',
        name: '/pages/property/maintainanceTaskManage',
        component: () => import('@/views/inspection/maintainanceTaskManageList.vue')
    },
    {
        path:'/pages/inspection/inspectionPlanDetail',
        name:'/pages/inspection/inspectionPlanDetail',
        component: () => import('@/views/inspection/inspectionPlanDetailList.vue')
        },
]